module.exports = __webpack_public_path__ + "img/giropay.15ea8e75.png";